import { PurchaseOrder } from "domain/entities/purchase-order";
import { DataTable } from "primereact/datatable";
import { Column } from "primereact/column";
import { formatDateToPT } from "presentation/utils/formatDateToPT";
import { usePurchaseOrderStore } from "presentation/stores/use-purchase-order-store";

const PurchaseOrderStatusHistoryTab: React.FC = () => {
  const { purchaseOrder } = usePurchaseOrderStore();

  const histories = purchaseOrder?.purchaseOrderStatusHistories || [];

  return (
    <div className="card">
      <DataTable
        value={histories}
        emptyMessage="Nenhum histórico encontrado."
        size="small"
        stripedRows
      >
        <Column
          field="oldStatus"
          header="Status Anterior"
        />
        <Column
          field="newStatus"
          header="Novo Status"
        />
        <Column
          field="justification"
          header="Justificativa"
        />
        <Column
          field="createdBy"
          header="Alterado por"
        />
        <Column
          field="createdAt"
          header="Data"
          body={(rowData) => formatDateToPT(rowData.createdAt)}
        />
      </DataTable>
    </div>
  );
};

export default PurchaseOrderStatusHistoryTab;
